/**
 * NE mijenjati u direktne Drive linkove.
 *
 * Google Drive gusi hotlinkanje - kad browser jednog posjetitelja zatrazi vise
 * slika odjednom, vecinu odbije (ERR_BLOCKED_BY_ORB). Zato slike idu kroz
 * Netlify Image CDN: Netlify ih dohvati sa svog servera (sto radi bez problema),
 * pretvori u WebP i posluzuje sa svog CDN-a. Dopustene domene su u netlify.toml.
 *
 * Lokalno Netlify Image CDN ne postoji pa se vracamo na direktni Drive URL -
 * ondje galerija zna imati rupa u slikama. U produkciji to nije slucaj.
 */

const LOKALNI_HOSTOVI = ["localhost", "127.0.0.1", "[::1]"];

export const KORISTI_NETLIFY_SLIKE =
  typeof window !== "undefined" &&
  !LOKALNI_HOSTOVI.includes(window.location.hostname);

export function driveSlikaUrl(id, sirina) {
  const izvor = `https://lh3.googleusercontent.com/d/${id}=w${sirina}`;

  if (!KORISTI_NETLIFY_SLIKE) {
    return `https://drive.google.com/thumbnail?id=${id}&sz=w${sirina}`;
  }

  return `/.netlify/images?url=${encodeURIComponent(izvor)}&w=${sirina}&fm=webp`;
}

/**
 * Popis istih slika u vise sirina. Uz atribut "sizes" browser sam bira
 * najmanju koja mu treba - na mobitelu povuce malu, na velikom ekranu vecu.
 */
export function driveSrcSet(id, sirine) {
  return sirine
    .map((sirina) => `${driveSlikaUrl(id, sirina)} ${sirina}w`)
    .join(", ");
}
